<template>
    <div>
        <div class="content-caption dashed">
            <span>整体操作:</span>
            <el-checkbox v-model="allSelect.allSelect" @change="handleCheckAllChange">全部选择(勾选后列表勾选无效)</el-checkbox>
            <div class="fr">
                <a class="swb-btn swb-btn-small" @click="update">更新</a>
            </div>
        </div>
        <el-tabs name="tabs" v-model="activeName">
            <el-tab-pane label="资产定义" name="zcdy">
                <div class="content-caption dashed">
                    <el-checkbox v-model="allSelect.zcdy">全部选择(勾选后列表勾选无效)</el-checkbox>
                </div>
                <swb-mercht-devc-def-list-for-select :filter="filter" :checkBox="true" ref="swb_mercht_devc_def_list_for_select"></swb-mercht-devc-def-list-for-select>
            </el-tab-pane>
            <el-tab-pane label="资产" name="devc">
                <div class="content-caption dashed">
                    <el-checkbox v-model="allSelect.devc">全部选择(勾选后列表勾选无效)</el-checkbox>
                </div>
                <swb-shop-device-list-for-select :filter="filter" :checkBox="true" ref="device_select_list"></swb-shop-device-list-for-select>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import assetApi from '../../api/asset'

    import SwbDevcCatListForSelect from './DevcCatListForSelect';
    Vue.regist(SwbDevcCatListForSelect);

    import SwbMerchtDevcDefListForSelect from '../devcDef/MerchtDevcDefListForSelect';
    Vue.regist(SwbMerchtDevcDefListForSelect);

    import SwbShopDeviceListForSelect from '../devc/ShopDeviceListForSelect';
    Vue.regist(SwbShopDeviceListForSelect);

    //
    export default {
        name: 'swb-asset-kind-sync',
        desc: '',
        props: {
            filter: {
                type: Object,
                default: {}
            },
            updateClick: {
                type: Function,
                default: null
            },
            type: {
                type: String,
                default: null
            }
        },
        data: function () {
            return {
                activeName: 'zcdy',
                allSelect: {
                    allSelect: false,
                    zcdy: false,
                    zcdyIds: [],
                    devc: false,
                    devcIds: [],
                }
            }
        },
        created: function () {
            if(this.type == 'devcCat') {
                this.activeName = 'zcdy';
            }
            let theLoad = MsgBox.loading();
            setTimeout(function () {
                theLoad.hide();
            }, 5000)
        },
        methods: {
            handleCheckAllChange(){
                let allSelect = this.allSelect;
                if(allSelect.allSelect) {
                    allSelect.zcdy = true;
                    allSelect.devc = true;
                } else {
                    allSelect.zcdy = false;
                    allSelect.devc = false;
                }
                this.allSelect = allSelect;
            },
            update(){
                let allSelect = this.allSelect;
                //
                let selectResult = null;
                //
                selectResult = this.$refs.swb_mercht_devc_def_list_for_select.getDlgResult();
                if(selectResult.type == 'info') {
                    allSelect.zcdyIds = selectResult.data.pluck('id');
                }
                //
                selectResult = this.$refs.device_select_list.getDlgResult();
                if(selectResult.type == 'info') {
                    allSelect.devcIds = selectResult.data.pluck('id');
                }
                //
                this.updateClick(allSelect);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/categ/AssetKindSync.vue